export const GET_PROERTY_VERIFY_LISTS = '[Property Verify Action] Get property verify list';
export const CONFIRMED_GET_PROERTY_VERIFY_LISTS = '[Property Verify Action] Confirmed Get property verify list';
export const GET_PROERTY_VERIFY_MESSAGES = '[Property Verify Action] Get property message list';
export const CONFIRMED_GET_PROERTY_VERIFY_MESSAGES = '[Property Verify Action] Confirmed Get property message list';
